import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
import FormModal from './FormModal';
// ─────────────────────────────────────────────────────────────────────────────
// Compact page factory for simpler pages
// ─────────────────────────────────────────────────────────────────────────────
const makeSimplePage = ({ title, subtitle, Icon, color, ctrl, columns: getCols, defaultForm, formFields: getFields, emptyTitle, statusOptions = ['Draft','Completed','Cancelled'] }) => {
  return ({ companyId }) => {
    const crud = useCRUD(ctrl, companyId);
    const [showForm, setShowForm] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [saving, setSaving]     = useState(false);
    const [errors, setErrors]     = useState([]);
    const [form, setForm]         = useState({ ...defaultForm, companyId });
    const set = (k,v) => setForm(p=>({...p,[k]:v}));

    const openAdd  = () => { setEditItem(null); setForm({...defaultForm,companyId}); setErrors([]); setShowForm(true); };
    const openEdit = (r) => { setEditItem(r); setForm({...r}); setErrors([]); setShowForm(true); };
    const handleSave = async () => {
      setSaving(true); setErrors([]);
      const res = editItem ? await ctrl.update(editItem.id,form) : await ctrl.create(form);
      setSaving(false);
      if (res.success) { crud.show(res.message); setShowForm(false); crud.fetchAll(); }
      else setErrors(res.errors?.length?res.errors:[res.message]);
    };

    const cols = getCols(crud, openEdit);

    return (
      <div style={S.page}>
        {crud.ToastEl}{crud.Dialog}
        <PageHeader title={title} subtitle={subtitle} Icon={Icon} color={color}
          action={<button style={S.btnPri} onClick={openAdd}><Plus size={15}/> Add New</button>} />
        <div style={S.card}>
          <div style={{ padding:'14px 14px 0' }}>
            <FilterBar search={crud.search} onSearch={crud.setSearch}
              filters={[{ key:'status', value:crud.filters.status||'All', onChange:v=>crud.setFilters(p=>({...p,status:v==='All'?'':v})), options:[{value:'All',label:'All Status'},...statusOptions.map(s=>({value:s,label:s}))] }]} />
          </div>
          <DataTable columns={cols} data={crud.data} loading={crud.loading} emptyTitle={emptyTitle}
            page={crud.page} totalPages={crud.totalPages} onPageChange={crud.setPage} total={crud.total} />
        </div>
        {showForm && (
          <FormModal title={editItem?`Edit ${title}`:`New ${title}`} onClose={()=>setShowForm(false)} onSave={handleSave} saving={saving} maxWidth={720}>
            <ErrList errors={errors} />
            <FormGrid>{getFields(form, set)}</FormGrid>
          </FormModal>
        )}
      </div>
    );
  };
};
export default makeSimplePage;